import { monospacePreStyles } from 'app/shared/styles/monospacePre.styles';

export const accordionStyles = {
  boxShadow: 'none',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  borderRadius: ({ shape }) => shape.radius?.l,
  backgroundColor: ({ palette }) => palette.background.paper,
};

// Flat-file records are tab-separated and XML is indented, so lines stay whole and scroll sideways instead of wrapping.
// A long payload scrolls both ways, and the global scrollbar styling leaves the corner where the two scrollbars meet
// at its white default, a bright square in the dark theme.
export const payloadStyles = {
  ...monospacePreStyles,
  maxHeight: '480px',
  whiteSpace: 'pre',
  wordBreak: 'normal',
  overflowX: 'auto',
  '&::-webkit-scrollbar-corner': {
    backgroundColor: 'transparent',
  },
};
